module.exports = __webpack_public_path__ + "static/media/twins_blue.97d56222.jpg";